import styled from "styled-components";
import { Color, Space, Typography } from "../../../settings";

import TransitionLink from "gatsby-plugin-transition-link";

export const Wrapper = styled.article`
  & + & {
    margin-top: ${Space.xxxLarge.rem};
  }
`;

export const ArrowWrapper = styled.div`
  display: inline-block;
  margin-left: ${Space.default.rem};
`;

export const Link = styled(TransitionLink)`
  color: ${Color.black};
  text-decoration: none;

  .line {
    transform: scaleX(1) !important;
  }

  &:hover {
    .line {
      transform: scaleX(0.6) !important;
    }
  }
`;

export const Date = styled.p`
  margin: 0;
  margin-bottom: ${Space.small.rem};
`;

export const Title = styled.h2`
  margin: 0;
  margin-bottom: ${Space.small.rem};
`;

export const Summary = styled.p`
  font-size: ${Typography.large.rem};
  margin: 0;
`;
